module.exports = __webpack_public_path__ + "static/sportreisen-6ca55c147af90ac46bd917b9adf3c483.svg";